import React from 'react';

interface ErrorBoundaryAlertBannerProps {
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryAlertBanner extends React.Component<ErrorBoundaryAlertBannerProps, State> {
  constructor(props: ErrorBoundaryAlertBannerProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(_error: boolean) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return null;
    }

    return this.props.children;
  }
}

export default ErrorBoundaryAlertBanner;
